import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[hostAutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    if (this.el && this.el.nativeElement) {
      setTimeout(() => {
        this.el.nativeElement.focus();
      },300)
    }
  }

}
